import React, { useState, useEffect } from 'react';
import { Input } from '@progress/kendo-react-inputs';
import { Error } from '@progress/kendo-react-labels';
import { isExcludedFromUppercase } from 'src/Basic/SDOExtension';

const UpperCaseTextInput = (props) => {
    const { onChange, autoUppercase = true, checked, value, style = { height: '40px', "textAlign": "left" }, ...otherProps } = props;

    // 判斷是否為 Controlled 元件 (是否有傳入 value 屬性)
    const isControlled = props.hasOwnProperty('value');
    // 如果是 Uncontrolled，內部維護 state 來處理轉大寫後的顯示
    const [internalValue, setInternalValue] = useState(otherProps.defaultValue || "");

    // 當外部 value 改變時，同步 internalValue (雖然 controlled 模式下主要使用 props.value)
    useEffect(() => {
        if (value !== undefined) {
            setInternalValue(value || "");
        }
    }, [value]);

    const handleChange = (e) => {
        let val = e.value;
        const name = otherProps.name || (e.target && e.target.name) || "";
        const id = otherProps.id || (e.target && e.target.id) || "";
        const type = (otherProps.type || otherProps.TYPE || (e.target && e.target.type) || "").toLowerCase();

        // 自動排除特定欄位：密碼、驗證碼、Email (使用共用函式)
        const isExcluded = isExcludedFromUppercase(type, name, id);

        if (autoUppercase && !isExcluded && typeof val === 'string' && val) {
            val = val.toUpperCase();
        }

        // 如果是 Uncontrolled，更新內部狀態以觸發重新渲染顯示大寫
        if (!isControlled) {
            setInternalValue(val);
        }

        if (onChange) {
            onChange({
                ...e,
                value: val,
                target: {
                    ...e.target,
                    name: name,
                    value: val
                }
            });
        }
    };

    // 最終顯示的值：Controlled 優先使用 props.value (並處理 null)，否則使用 internalValue
    const finalValue = isControlled ? (value ?? "") : internalValue;

    return (
        <>
            <Input
                style={style}
                {...otherProps}
                value={finalValue}
                onChange={handleChange}
            >
            </Input>
            {Object.hasOwn(props, "touched") ? (props.touched && props.error && <Error>{props.error}</Error>) : <Error>{props.error}</Error>}
        </>
    )
}

export default React.memo(UpperCaseTextInput)